const WITHHOLD_ENUM = {
  OPEN: 1,
  CLOSE: 0,
}

// 常量定义
const WITHHOLD_OPTIONS = [
  { label: '开启', value: 1 },
  { label: '关闭', value: 0 },
]

const PAY_METHOD_OPTIONS = [
  { label: '线上支付', value: 40 },
  { label: '网约钱包支付', value: 20 },
  { label: '支付宝支付', value: 50 },
]

const PAY_FREQUENCY_OPTIONS = [
  { label: '日扣', value: 1 },
  { label: '周扣', value: 2 },
]

const WEEKLY_DEDUCTION_DAY_OPTIONS = [
  { label: '周一', value: 1 },
  { label: '周二', value: 2 },
  { label: '周三', value: 3 },
  { label: '周四', value: 4 },
  { label: '周五', value: 5 },
  { label: '周六', value: 6 },
  { label: '周日', value: 7 },
]

const PAY_LIMIT_OPTIONS = [
  { label: '不限额', value: 'unlimited' },
  { label: '周期内限额', value: 'limited' },
]

const SIGN_METHOD_ENUM = {
  ONLINE: 0,
  OFFLINE: 1,
}

const SIGN_CHANNEL_ENUM = {
  OFFLINE: 1,
  ONLINE: 2,
}

const SIGN_METHOD_OPTIONS = [
  { label: '线上签署', value: 2 },
  { label: '线下签署', value: 1 },
]

const CHANNEL_STATE_ENUM = {
  PENDING_SYNC: 0, // 待同步
  CONFIRM: 1, // 确认中
  AGREED: 2, // 已同意
  REJECTED: 3, // 已拒绝
  SYNC_FAILED: 4, // 同步失败(超时)
}

const SIGN_STATUS_ENUM = {
  PENDING_INITIATE: 0,
  PENDING_APPROVAL: 10,
  WECHAT_QR_PENDING_SCAN: 20,
  PENDING_SIGN: 30,
  RE_PUSH_DRIVER: 35,
  ALIPAY_QR_PENDING_SCAN: 40,
  SIGN_COMPLETED: 50,
}

const SIGN_STATUS = {
  [SIGN_STATUS_ENUM.PENDING_INITIATE]: '待发起',
  [SIGN_STATUS_ENUM.PENDING_APPROVAL]: '待审批',
  [SIGN_STATUS_ENUM.WECHAT_QR_PENDING_SCAN]: '微信二维码待扫码',
  [SIGN_STATUS_ENUM.PENDING_SIGN]: '待签署(扫码，已发起签署)',
  [SIGN_STATUS_ENUM.ALIPAY_QR_PENDING_SCAN]: '支付宝二维码待扫码',
  [SIGN_STATUS_ENUM.SIGN_COMPLETED]: '签署完成',
}

export {
  WITHHOLD_OPTIONS,
  PAY_METHOD_OPTIONS,
  PAY_FREQUENCY_OPTIONS,
  WEEKLY_DEDUCTION_DAY_OPTIONS,
  PAY_LIMIT_OPTIONS,
  SIGN_METHOD_OPTIONS,
  SIGN_STATUS_ENUM,
  SIGN_STATUS,
  CHANNEL_STATE_ENUM,
  SIGN_METHOD_ENUM,
  SIGN_CHANNEL_ENUM,
  WITHHOLD_ENUM,
}
